import { FC } from 'react';
import { ICustomTooltipProps } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import Text, { TEXT } from '~/view/components/Text/Text';

interface IProps {
  className: string;
  itemName: string;
  tooltip?: Partial<ICustomTooltipProps>;
}

const CashbackListColumnTitle: FC<IProps> = ({ className, itemName, tooltip }): JSX.Element => {
  return (
    <li className={className}>
      <Text type={TEXT.COLUMN_TITLE} text={itemName} tooltip={tooltip} />
    </li>
  );
};

export default CashbackListColumnTitle;
